import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoMessages = _resolveComponent("InfoMessages")!
  const _component_Status = _resolveComponent("Status")!
  const _component_Charge = _resolveComponent("Charge")!
  const _component_ExchangeHistory = _resolveComponent("ExchangeHistory")!
  const _component_CampaignDetailCards = _resolveComponent("CampaignDetailCards")!
  const _component_UserInquiryCard = _resolveComponent("UserInquiryCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.myPageConfig)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.myPageConfig.image_path,
          alt: "myPageImage",
          class: "w-full sm:w-6/12 sm:px-1 my-0 mx-auto"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.failedExchangeRequests.items.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "mx-2 mt-2 sm:w-6/12 w-full bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-sm relative" }, [
            _createElementVNode("p", null, " 結果の確定していない応募があります。大変お手数ですが、結果の確定までしばらくお待ちください ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_InfoMessages, { infoMessages: _ctx.infoMessages }, null, 8, ["infoMessages"]),
    (_ctx.myPageConfig?.point_visibility)
      ? (_openBlock(), _createBlock(_component_Status, {
          key: 2,
          wallet: _ctx.wallet
        }, null, 8, ["wallet"]))
      : _createCommentVNode("", true),
    (_ctx.myPageConfig && !_ctx.myPageConfig.point_visibility)
      ? (_openBlock(), _createBlock(_component_Charge, {
          key: 3,
          "consent-description-visible": false
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ExchangeHistory),
    _createVNode(_component_CampaignDetailCards),
    _createVNode(_component_UserInquiryCard)
  ]))
}